/**
 * Contentsquare: ініціалізація тега та pageview при SPA-навігації.
 * @see https://docs.contentsquare.com/en/web/
 * @see https://support.contentsquare.com/hc/en-us/articles/37271848593297
 */

const CONTENTSQUARE_TAG_ID = '03a7af59b2dae'

function getPath(): string {
  return window.location.pathname + window.location.hash.replace('#', '?__')
}

function initContentsquare(): void {
  window._uxa = window._uxa || []

  if (typeof (window as any).CS_CONF === 'undefined') {
    window._uxa.push(['setPath', getPath()])
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://t.contentsquare.net/uxa/${CONTENTSQUARE_TAG_ID}.js`
    document.getElementsByTagName('head')[0]?.appendChild(script)
  } else {
    window._uxa.push(['trackPageview', getPath()])
  }
}

export default defineNuxtPlugin(() => {
  initContentsquare()

  const router = useRouter()
  router.afterEach((to) => {
    const path = to.fullPath.replace(/^#/, '?__')
    if (Array.isArray(window._uxa)) {
      window._uxa.push(['trackPageview', path])
    }
  })
})

declare global {
  interface Window {
    _uxa?: unknown[]
  }
}
